import { render, staticRenderFns } from "./ImagensComp.vue?vue&type=template&id=68e175c1&"
import script from "./ImagensComp.vue?vue&type=script&lang=js&"
export * from "./ImagensComp.vue?vue&type=script&lang=js&"
import style0 from "./ImagensComp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ImagensComp.vue"
export default component.exports